function updatePriceinBtn(){
  const priceBtn = document.querySelector(".nwrapperPriceBtn");
  const quantity__input = document.querySelector('.product__info-container .quantity__input');
  const paywhirlselected = document.querySelector('[name="paywhirl-plan-selector-group"]:checked');
  
  let q = 1;
  let priceselect = 0;
  
  if(Boolean(priceBtn)){
    priceselect = parseFloat(priceBtn.dataset.firstprice.replace(",","."));
  }
  if(Boolean(quantity__input)){
    q = parseInt(quantity__input.value);
  }


    let newElt = paywhirlselected.parentNode.querySelector(`.paywhirl-price`);
    console.log('newElt');
    console.log(newElt);
    let pricenum = newElt.getAttribute('data-pricenum');
    const subPriceDhs = pricenum.includes('Dhs.');

    if (subPriceDhs) {
      console.log('subePriceDhs: ' + subPriceDhs);
      priceBtn.innerHTML = `• ${pricenum}`;
    } else {
      priceBtn.innerHTML = `• Dhs. ${pricenum}`;
      console.log('NOT DHS');
    }

}
  
document.addEventListener("DOMContentLoaded", () => {
  const quantity__input = document.querySelector('.product__info-container .quantity__input');
  if(Boolean(quantity__input)){
    quantity__input.addEventListener("input",e=>{
      updatePriceinBtn();
    });
    quantity__input.addEventListener("change",e=>{
      updatePriceinBtn();
    });
  }

  /*let variantSelector = document.querySelector('.product__info-wrapper [name=id]');
  variantSelector.addEventListener('change', function() {
    let selectedVariantId = variantSelector.value;
    let variantData = JSON.parse(variantjson.textContent);
    let getcurrentvariant = variantData.find(data => { return data.id.toString() == selectedVariantId });
    let htmlprice = getcurrentvariant.price/100;
  });*/
  
  const btnsOpenVideo = document.querySelectorAll('.nuestros-clientes-carousel modal-opener .product-popup-modal__button');
  btnsOpenVideo.forEach(btn=>{
    btn.addEventListener("click",e=>{
      let typevideo = btn.dataset.typevideo;
      let dataid = btn.dataset.mediaId;
      let modalid = btn.dataset.modalid;
      if(typevideo=="youtube"){
        let url = `https://www.youtube.com/embed/${dataid}?enablejsapi=1`
        let iFrameObj = document.createElement('iframe');
        iFrameObj.classList.add("js-youtube");
        iFrameObj.src = url;
        let modalOpenVideo = document.querySelector(`#${modalid} deferred-media`);
        let modalOpenVideoIfram = document.querySelector(`#${modalid} deferred-media iframe`);
        if(Boolean(modalOpenVideoIfram)){
          //
        }else{
          modalOpenVideo.appendChild(iFrameObj);
          iFrameObj.addEventListener("load", l=>{
            modalOpenVideo.setAttribute("loaded", true);
          });  
        }
        
      }
      console.log(btn);
    });
  });
  
  const inputVariant = document.querySelector('.product-form .form input[name="id"]');
  const variantjson = document.querySelector('variant-selects [type="application/json"], variant-radios [type="application/json"]');
  window.variantjson = document.querySelector('variant-selects [type="application/json"], variant-radios [type="application/json"]');
  
  const intensidad = [{
      id:42672701145302,
      intensidad:4,
      color:"floral"
    },
    {
      id:37744675717285,
      intensidad:0,
      color:"no"
    },
    {
      id:37744675750053,
      intensidad:2,
      color:"lavanda"
    },
    {
      id:43494948339926,
      intensidad:0,
      color:"no"
    },
    {
      id:43494948274390,
      intensidad:4,
      color:"floral"
    },
    {
      id:43494948307158,
      intensidad:2,
      color:"lavanda"
    }
  ];

  let onetimeLabel = document.querySelector("#paywhirl-one-time-purchase-group .paywhirl-label");
  let boxPrice = document.createElement("div");
  boxPrice.classList.add("boxPrice", "paywhirl-price");
  
  if(Boolean(variantjson)){
    let variantData = JSON.parse(variantjson.textContent);
    let getcurrentvariant = variantData.find(data => { return data.id.toString() == inputVariant.value });
    let htmlprice = getcurrentvariant.price/100;
    boxPrice.setAttribute("data-pricenum", htmlprice);
    let numStr = htmlprice.toString(); // convert to string
    let newNumStr = numStr.replace('.', ','); 
    //boxPrice.innerHTML= `${htmlprice.replace(".", ",")} lei`;

    const currentURL = window.location.href;
    const targetText = 'natulim.ae';
    let newCurrencyFormat = 'Dhs.';
    let nonEmirates = true;
    
    if (currentURL.includes(targetText)) {
      nonEmirates = false;
    } 

    if (nonEmirates) {
      boxPrice.innerHTML = `${newNumStr} lei`;
    } else {
      boxPrice.innerHTML = `${newCurrencyFormat} ${newNumStr}`;
    }
    
    if(Boolean(onetimeLabel)){
      onetimeLabel.append(boxPrice);
    }
  }else{
    let priceBtn = document.querySelector(".nwrapperPriceBtn");
    if(Boolean(priceBtn)){
      boxPrice.setAttribute("data-pricenum", `${priceBtn.dataset.firstprice.replace(",",".")}`);
      boxPrice.innerHTML= `${priceBtn.dataset.firstprice.replace(".", ",")} lei`;
      if(Boolean(onetimeLabel)){
        onetimeLabel.append(boxPrice);
      }
    }
    
  }

  let allLabels = document.querySelectorAll(".paywhirl-label");
  let allinputspayw = document.querySelectorAll('[name="paywhirl-plan-selector-group"]');
  
  allinputspayw.forEach(label=>{
    label.addEventListener("input", e=>{
      updatePriceinBtn();
      /*let priceBtn = document.querySelector(".nwrapperPriceBtn");
      let pricewrapp = label.querySelector(".paywhirl-price");
      if(Boolean(pricewrapp.textContent)){
        priceBtn.innerHTML="• "+pricewrapp.textContent;
      }*/
    });
  });
  if(Boolean(inputVariant)){
    inputVariant.addEventListener("change", e => {
      if(Boolean(window.variantjson)){
        let variantData = JSON.parse(window.variantjson.textContent);
        getcurrentvariant = variantData.find(data => { return data.id.toString() == e.target.value });
        if(getcurrentvariant){
          let htmlprice = getcurrentvariant.price/100;
        }
      }
      let getvariant = window.intensidad.filter(data => { return data.id.toString() == e.target.value });
      if(getvariant.length>0){
        let fraganceWrapperCont = document.querySelector('.fraganceWrapper');
        let fraganceWrapper = document.querySelectorAll('.fraganceWrapper .intensityItem');
        
        //fraganceWrapperCont.classList.remove("lavanda", "floral", "no");
        //fraganceWrapperCont.classList.add(getvariant[0].color);
        
        fraganceWrapper.forEach(item=>{
          item.classList.remove("checkint");
          item.setAttribute('style', `--intense:${getvariant[0].color};`);
        });
        
        fraganceWrapper.forEach((item, index)=>{
          if((index+1)<=getvariant[0].intensidad){
            item.classList.add("checkint");
          }
    
          //item.classList.remove("checkint");
        });
      }
    });
  }

  let svgchecks = document.querySelectorAll('.paywhirl-icon-circle-check');
  svgchecks.forEach(svgch => {
    svgch.setAttribute('viewBox','0 0 100 100');
    svgch.innerHTML='<circle cx="50" cy="50" fill="none" stroke-width="8" stroke="#2a2a2a" r="42"></circle><circle cx="50" cy="50" fill="#ADCF3B" r="30"></circle>';
  });
  let svgcircle = document.querySelectorAll('.paywhirl-icon-circle');
  svgcircle.forEach(svgcir => {
    svgcir.setAttribute('viewBox','0 0 100 100');
    svgcir.innerHTML='<circle cx="50" cy="50" fill="none" stroke-width="8" stroke="#2a2a2a" r="42"></circle>';
  });
  
  let selectplans = document.querySelectorAll('.paywhirl-plan-selector-plan select');
  selectplans.forEach(select => {

    let boxOptions = document.createElement("div");
    boxOptions.classList.add("boxSelectorPlan");
    let stringconcat="";
    let textbottomdiv="";
    if(select.options.length>0){
      Array.from(select.options).forEach(option=>{
        if(option.value != "" ){
          let classselected = option.selected?"active":"";
          textbottomdiv += option.selected?option.innerText:"";
          let textsplit = option.innerText.split("-");
          stringconcat += `<div class="optbox ${classselected}" data-idopt="${option.value}" data-text="*${option.innerText}">${textsplit[0]}</div>`;
        }
      });
    }
    let alltextstring = `<div class="wrapperOptions">${stringconcat}</div>`;
    //let alltextstring = `<div class="wrapperOptions">${stringconcat}</div><div class="textchangeoptions">*${textbottomdiv}</div>`;
    boxOptions.innerHTML = alltextstring;
    select.parentNode.insertBefore(boxOptions, select);
    
    boxOptions.addEventListener("click", e => {
      if(e.target.classList.contains("optbox")){
        let el = e.target;
        let siblings = [...el.parentNode.children].filter((child) => child !== el);
        siblings.forEach(sibling=>sibling.classList.remove("active"));
        el.classList.add("active");
        el.parentNode.parentNode.nextElementSibling.value = el.dataset.idopt;

        const evt = new Event("change", {"bubbles":true, "cancelable":false});
        el.parentNode.parentNode.nextElementSibling.dispatchEvent(evt);
        /*
        let event = new CustomEvent("change");
        el.parentNode.parentNode.nextElementSibling.dispatchEvent(event);
        */
      }
      

    });
  });
  
  let btnsloadmore = document.querySelectorAll(".loadmore_btn-wrapper");
  if(Boolean(btnsloadmore)){
    btnsloadmore.forEach(btn=>{
      btn.addEventListener("click",e=>{
        e.preventDefault();
    
        Array.from(btn.previousSibling.children).forEach(item=>{
          item.classList.remove("hidden");
        });
        btn.classList.add("hidden");

      });
    })
  }
  
  // Select the node that will be observed for mutations
  const targetNode = document.getElementById('cart-icon-bubble');
  const config = { attributes: false, childList: true, subtree: true };
  /*const callback = function(mutationsList, observer) {
    // Use traditional 'for loops' for IE 11
    mutationsList.forEach(mutation=>{
      console.log(mutation);
      let lastcont = mutation.target.lastChild;
      if(Boolean(lastcont)){
        if(lastcont.classList.contains("cart-count-bubble")){
          let nroitems = lastcont.querySelector("[aria-hidden=true]").innerText;
          document.querySelector(".drawer__heading span").innerText= `(${nroitems})`;
        }
      }
    })
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);*/

  // ======================
  const targetPrice = document.querySelector('.paywhirl-plan-selector-price .paywhirl-price');
  if(Boolean(targetPrice)){
    const callbackPrice = function(mutationsList, observerPrice) {
      // Use traditional 'for loops' for IE 11
      mutationsList.forEach(mutation=>{
        if(mutation.type=="childList" && mutation.addedNodes.length>0){
          console.log(mutation);
          if(targetPrice.innerText != ""){
            let convertnumber=targetPrice.textContent.replace("lei", "").replace(",", ".");
            targetPrice.setAttribute("data-pricenum", convertnumber);
            updatePriceinBtn();
            /*let priceBtn = document.querySelector(".nwrapperPriceBtn");
            priceBtn.innerHTML="• "+targetPrice.textContent;*/
          }
        }
      })
    };
  
    const observerPrice = new MutationObserver(callbackPrice);
    observerPrice.observe(targetPrice, config);
  }
});



